import React from 'react';
import {isElementOfType} from 'react/lib/ReactTestUtils';
import classnames from 'classnames';


function anyChildBoxes(reactChildren) {
  const children = [];
  React.Children.forEach(reactChildren, child => children.push(child));
  return children.some(child => isElementOfType(child, HBox) || isElementOfType(child, VBox));
}


export class VBox extends React.Component {

  render() {

    const {height, style, width, noJustify, children, isContainer, container, className, ...props} = this.props;
    const childBoxes = isContainer || container || anyChildBoxes(children);

    const cls = classnames(
      'VBox',
      'VBox--Width' + width,
      {
        'VBox--Container': childBoxes,
        'VBox--Content': !childBoxes,
        'VBox--NoJustify': childBoxes && noJustify
      },
      className
    );

    return (
      <div className={cls} style={{...style, height}} {...props}>{children}</div>
    );

  }

}

VBox.propTypes = {
  width: React.PropTypes.oneOf([1, 2, 4])
};

VBox.defaultProps = {
  width: 1
};


export class HBox extends React.Component {

  render() {

    const {height, style, width, noJustify, children, isContainer, container, className, ...props} = this.props;
    const childBoxes = isContainer || container || anyChildBoxes(children);

    const cls = classnames(
      'HBox',
      'HBox--Width' + width,
      {
        'HBox--Container': childBoxes,
        'HBox--Content': !childBoxes,
        'HBox--NoJustify': childBoxes && noJustify
      },
      className
    );

    return (
      <div className={cls} style={{...style, height}} {...props}>{children}</div>
    );

  }

}

HBox.propTypes = {
  width: React.PropTypes.oneOf([1, 2, 4])
};

HBox.defaultProps = {
  width: 1
};



// WEBPACK FOOTER //
// ./src/components/Box.js